<div class="AmCounter-content" *ngIf="!newdata">
  <button
    (click)="onMinus()"
    [disabled]="!enableMinus || count == 0"
    [ngClass]="{ 'AmCounter-disable': !enableMinus || count == 0 }"
    class="btn btn-light"
  >
    <span>-</span>
  </button>
  <div class="fs-22px">{{ count }}</div>
  <button class="btn btn-light" (click)="onPlus()" [ngClass]="{ 'AmCounter-disable': !enablePlus }">
    <span>+</span>
  </button>
</div>
<div class="bag-buttons" *ngIf="newdata">
  <button
    class="bag-button"
    [disabled]="count == 0 || !enableMinus"
    [ngClass]="{ disabled: count == 0 || !enableMinus, active: count > 0 && enableMinus }"
    (click)="onMinus()"
  >
    -
  </button>
  <div class="bag-count">
    <span>{{ count }}</span>
  </div>
  <button class="bag-button" (click)="onPlus()" [disabled]="!enablePlus && !blockPlus">+</button>
</div>
